export enum ReceiptPrinterConnectionTypeEnum {
  BT = 'BT',
  TCP = 'TCP'
}
